import React, { useState, useEffect } from 'react';
import { FaBell, FaUserCircle, FaSignOutAlt, FaBars } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useMobileMenu } from '../contexts/MobileMenuContext';
import { getToken, clearToken, checkTokenAndRedirect } from '../../../utils/tokenManager';
import './Topbar.css';

const Topbar = () => {
    const navigate = useNavigate();
    const [showDropdown, setShowDropdown] = useState(false);
    const [userProfile, setUserProfile] = useState(null);
    const { toggleMobileMenu } = useMobileMenu();

    useEffect(() => {
        // Check token validity on component mount
        if (!checkTokenAndRedirect(navigate)) {
            return;
        }

        // Set up interval to check token validity every minute
        const tokenCheckInterval = setInterval(() => {
            if (!checkTokenAndRedirect(navigate)) {
                clearInterval(tokenCheckInterval);
            }
        }, 60000);

        // Cleanup interval on component unmount
        return () => clearInterval(tokenCheckInterval);
    }, [navigate]);

    const handleLogout = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You will be logged out of the system",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2563eb',
            cancelButtonColor: '#95a5a6',
            confirmButtonText: 'Yes, logout'
        }).then((result) => {
            if (result.isConfirmed) {
                clearToken();
                navigate('/');
            }
        });
    };

    return (
        <div className="topbar">
            <div className="topbar-left">
                <button className="menu-btn" onClick={toggleMobileMenu} aria-label="Toggle Menu">
                    <FaBars className="menu-icon" />
                </button>
                <h2 style={{color: 'white', marginLeft: '25px'}}>Dashboard</h2>
            </div>
            
            <div className="topbar-right">
                <div className="user-profile" onClick={() => setShowDropdown(!showDropdown)}>
                    <FaUserCircle className="avatar" />
                    <span className="username">Administrator</span>
                    
                    {showDropdown && (
                        <div className="dropdown-menu">
                            <div className="dropdown-header">
                                <FaUserCircle className="dropdown-avatar" />
                                <div className="user-info">
                                    <span className="user-name">{userProfile?.userName || 'Overall Manager'}</span>
                                    <span className="user-role">Administrator</span>
                                </div>
                            </div>
                            <div className="dropdown-divider"></div>
                            <button className="dropdown-item" onClick={handleLogout}>
                                <FaSignOutAlt />
                                <span>Logout</span>
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Topbar;
